/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["[_nghost-%COMP%]     .mat-table{table-layout:fixed}[_nghost-%COMP%]     .mat-table .mat-column-image{width:200px}"];
export { styles as styles };

